module.exports = "/_next/static/images/IncreaseEngagement@2x-6c4515d2cea7978e2b7eed0b6a09c5cf.png";